import { REACTION_SETS, type Reaction, type Role } from '@xox/shared'

/** Accessible names for every reaction id (buttons and floating bubbles). */
export const REACTION_LABELS: Record<Reaction, string> = {
  lol: 'Haha',
  fire: 'On fire',
  wow: 'Wow',
  clap: 'Applause',
  cry: 'Noooo',
  think: 'Hmm',
  snow: 'Snow burst',
  chill: 'Chill',
  roar: 'Yeti roar',
  gg: 'GG',
  flag: 'Finish flag',
  splash: 'Splash',
}

/** Both games draw their reactions: XOX in components/art/xoxStickers, Ice in ice/art/stickers. */
export type XoxReaction = (typeof REACTION_SETS.xox)[number]
export type IceReaction = (typeof REACTION_SETS.ice)[number]

export function isIceReaction(id: Reaction): id is IceReaction {
  return (REACTION_SETS.ice as readonly Reaction[]).includes(id)
}

const LANES = 5
const LANE_MIN = 15
const LANE_MAX = 85

export type LaneMode = 'role' | 'sender'

/**
 * Horizontal position (percent) a reaction bubble rises in. `role` (XOX): X left, O right,
 * spectators centre. `sender` (Ice, where the server tags every racer alike): a stable lane
 * from the sender's id so bubbles from different people don't stack.
 */
export function laneFor(mode: LaneMode, role: Role, senderId: string): number {
  if (mode === 'role') return role === 'X' ? 18 : role === 'O' ? 82 : 50
  return LANE_MIN + (hash(senderId) % LANES) * ((LANE_MAX - LANE_MIN) / (LANES - 1))
}

export function hash(s: string): number {
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0
  return Math.abs(h)
}
